import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { StudentService } from '../../../appshared/Main/student/student.service';
import { StudentYearService } from '../../../appshared/Main/student-year/student-year.service';
import { StudentYearModule } from '../../../appshared/Main/student-year/student-year.module';
import { ViewStudentYearModule } from '../../../appshared/view/view-student-year/view-student-year.module';

@Component({
  selector: 'app-moving-step1-about',
  templateUrl: './moving-step1-about.component.html',
  styleUrls: ['./moving-step1-about.component.scss']
})
export class MovingStep1AboutComponent implements OnInit {

    mainForm = new ViewStudentYearModule();

    isActive: boolean = false;
    public syid: number = 0;
    public tid: number = 0;
    public phone: string = '';
    private sub: any;
    constructor(public service: StudentYearService, private route: ActivatedRoute, private router: Router,
        public servStudent: StudentService,
        public servStudentYear: StudentYearService,) { }

    ngOnInit(): void {

        this.sub = this.route.params.subscribe(params => {
            this.syid = +params['syid'];
            this.phone = params['phone'];
            this.checkAvailbale();
        });
    }
    checkAvailbale() {

        this.service.getServiceFindParent(this.phone, this.syid)
            .subscribe(res => {

                var dataReg = res as ViewStudentYearModule[];
                this.mainForm = dataReg[0];

                this.tid = dataReg[0].gnTermsID;
                this.isActive = true;

            },
                (error: HttpErrorResponse) => {

                    this.router.navigate(['not_available']);

                });
    }


    onClickBT() {

        this.router.navigate(['mov_confirm_step2', { syid: this.syid, phone: this.phone, tid: this.tid }]);
    }

    onReject() {

         this.router.navigate(['']);
        //this.mainForm.status = "Accepted";
        //this.service.putService(this.mainForm).subscribe(
        //    res => {
        //        this.router.navigate(['']);
        //    },
        //    err => {
        //        console.log(err);
        //        this.router.navigate(['not_available']);
        //    }
        //);
    }
}
